import clsx from 'clsx';
import styles from './Trees.module.css';

const TreeStats = ({ value, label }: { value?: number; label: string }) => (
  <div className={styles.treeStats}>
    <div className="daymadeTypographyMBlack">
      {value?.toLocaleString('en-GB')}
    </div>
    <div className={clsx('daymadeTypographySRegular', styles.treeStatText)}>
      {label}
    </div>
  </div>
);

export default TreeStats;